import React from 'react';
import {
  Datagrid,
  DateField,
  TextField,
  ReferenceManyField,
  ReferenceField,
} from 'react-admin';
import { makeStyles } from '@material-ui/styles';
import { Pagination, NumberWithUnitField } from '../../../../components';

const useStyles = makeStyles({
  headerRoot: {
    paddingBottom: 0,
    width: '100%',
  },
});

const ListRetard = (props) => {
  const classes = useStyles();
  return (
    <ReferenceManyField
      {...props}
      classes={classes}
      reference="retard"
      target="cleaner_id"
      xs={12}
      perPage={10}
      pagination={<Pagination />}
    >
      <Datagrid>
        <DateField source="date" label="Date" textAlign="center" />
        <ReferenceField
          source="account_id"
          reference="account"
          textAlign="center"
          label="Compte"
        >
          <TextField source="name" label="Compte" />
        </ReferenceField>
        <NumberWithUnitField
          source="duree_retard"
          unit="minutes"
          label="Durée du retard"
        />
        <TextField source="commentaire" />
        <ReferenceField
          source="manager_id"
          reference="cleaner"
          textAlign="center"
          label="Manager"
        >
          <TextField source="fullname" label="Manager" />
        </ReferenceField>
      </Datagrid>
    </ReferenceManyField>
  );
};

export default ListRetard;
